import React from 'react';
interface SpeechBubbleProps {
  text: string;
  color?: 'pink' | 'orange' | 'yellow' | 'blue' | 'cream';
  className?: string;
}
export function SpeechBubble({
  text,
  color = 'pink',
  className = ''
}: SpeechBubbleProps) {
  const colors = {
    pink: 'bg-[#FF6B9D] text-white',
    orange: 'bg-[#FF8A3D] text-white',
    yellow: 'bg-[#FFD34D] text-[#2D2D2D]',
    blue: 'bg-[#BDE1FF] text-[#2D2D2D]',
    cream: 'bg-[#FFF8F2] text-[#FF6B9D]'
  };
  return <div className={`relative inline-block px-6 py-3 rounded-full font-bold text-sm tracking-wider uppercase shadow-sm ${colors[color]} ${className}`} data-id="element-96">
      {text}
      <div className={`absolute -bottom-2 left-6 w-4 h-4 rotate-45 ${colors[color].split(' ')[0]}`} style={{
      zIndex: -1
    }} data-id="element-97" />
    </div>;
}